import { useQuery } from '@tanstack/react-query';

import { getOfferingTransactionDocumentsPreviewAsPdf } from '@arrived/api_v2';
import { OfferingTransactionId } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { tradeDocumentsPdfQueryKeyFn } from './trades.keys';

export function useTradeDocumentsPreviewAsPdfQuery(tradeId?: OfferingTransactionId, options?: UseQueryOptions<Blob>) {
  return useQuery(tradeDocumentsPdfQueryKeyFn(tradeId!), () => getOfferingTransactionDocumentsPreviewAsPdf(tradeId!), {
    ...options,
    enabled: (options?.enabled ?? true) && tradeId != null,
  });
}
